<template>
  <Tab
    :list="tab.list"
    :current="tab.current"
    class="-mypage"
    @click-tab="clickTab"
  />
  <HeadingLv1 text="申込イベント一覧" />
  <div class="u-containar">
    <MypageContents :key="state.navKey">
      <Loader v-if="loading" />
      <template v-if="!loading">
        <div v-if="reservedEvents.length > 0" class="card-wrapper">
          <EventCardMypage
            v-for="(event, i) in reservedEvents"
            :key="i"
            :event="event"
            :clickCancel="
              () => {
                clickCancel(String(event.id))
              }
            "
          />
        </div>

        <Alert
          v-if="reservedEvents.length == 0"
          text="お申込みいただいたイベントはありません。"
        />

        <BackTo :link="'/mypage'" />
      </template>
    </MypageContents>

    <ModalBase
      v-if="state.showConfirmModal"
      @close-modal="state.showConfirmModal = false"
    >
      <div class="cnt">
        <p class="lead">
          <strong>
            本当にキャンセルしますか？
          </strong>
        </p>
        <p>
          この操作は取り消せません。再び申込みをしたい場合は、改めてイベント詳細ページから申込み手続きをお願いします。
        </p>
        <div class="modalButton">
          <p class="btn">
            <Button
              label="閉じる"
              :handleClick="
                () => {
                  $store.commit('unFixBody')
                  state.showConfirmModal = false
                }
              "
              thingray
            />
          </p>
          <p class="btn">
            <Button label="キャンセルする" :handleClick="cancelEvent" primary />
          </p>
        </div>
      </div>
    </ModalBase>
    <ModalComplete
      text='予約のキャンセルを<br class="hiddenPc" />受け付けました'
      :visivle="state.showCompleteModal"
      @close="
        () => {
          state.showCompleteModal = false
          $store.commit('unFixBody')
        }
      "
    />
  </div>
</template>

<script lang="ts">
import Tab from '@/components/elements/Tab.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import MypageContents from '@/components/block/MypageContents.vue'
import EventCardMypage from '@/components/block/EventCardMypage.vue'
import Loader from '@/components/elements/Loader.vue'
import Alert from '@/components/elements/Alert.vue'
import BackTo from '@/components/block/BackTo.vue'
import Button from '@/components/elements/Button.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import { useEvent } from '@/provider/event'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { reactive, defineComponent } from 'vue'
import ModalBase from '@/components/genenral/ModalBase.vue'
import ModalComplete from '@/components/genenral/ModalComplete.vue'
import { mypageTabItems } from '@/utils/commonDataset'

export default defineComponent({
  name: 'EventList',

  components: {
    Tab,
    HeadingLv1,
    MypageContents,
    EventCardMypage,
    Loader,
    Alert,
    BackTo,
    Button,
    ModalBase,
    ModalComplete
  },

  setup() {
    const router = useRouter()
    const store = useStore()
    const state = reactive({
      showConfirmModal: false,
      showCompleteModal: false,
      currentId: '',
      navKey: 0
    })
    const tab = reactive({
      list: mypageTabItems,
      current: 2
    })

    const clickTab = (i: number) => {
      router.push({ path: tab.list[i].link })
    }

    const userInfo = store.state.userInfo
    const getEventHistoryIds = (): number[] => {
      return userInfo.event_history.map(
        (item: { id: string; event_id: string }) => parseInt(item.event_id)
      )
    }

    const { reservedEvents, loadEventsFromHistoryIds, loading } = useEvent()
    loadEventsFromHistoryIds(100, getEventHistoryIds())

    const clickCancel = (id: string) => {
      state.showConfirmModal = true
      state.currentId = id
    }

    const cancelEvent = () => {
      store.commit('showLoading')
      const ajax = axiosSetting('app', 'action')

      ajax
        .post('/api/v1/event_cancel', {
          event_id: state.currentId
        })
        .then(() => {
          state.showConfirmModal = false
          state.showCompleteModal = true
          userInfo.event_history.splice(
            userInfo.event_history.findIndex(
              (item: { id: string; event_id: string }) =>
                item.event_id == state.currentId
            ),
            1
          )

          state.navKey++
          loadEventsFromHistoryIds(100, getEventHistoryIds())
        })
        .catch((err) => {
          try {
            if (err.response.status === 422) {
              const errors = err.response.data.err_msg

              Object.keys(errors).forEach((key: string) => {
                alert(errors[key][0])
              })
              return
            }

            store.commit('showSystemError', 'modal')
          } catch (e) {
            store.commit('showSystemError', 'modal')
          }
        })
        .then(() => {
          store.commit('closeLoading')
        })
    }

    return {
      state,
      tab,
      clickTab,
      loading,
      reservedEvents,
      clickCancel,
      cancelEvent
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.card-wrapper {
  display: grid;
  gap: 30px;
  @include mixins.media() {
    grid-template-columns: 1fr 1fr;
  }
}

.cnt {
  padding-left: 20px;
  padding-right: 20px;

  @include mixins.media() {
    padding-left: 50px;
    padding-right: 50px;
  }
}

.lead {
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  color: var.$color-main;

  > strong {
    font-weight: inherit;
  }

  & + p {
    margin-top: 10px;

    @include mixins.media() {
      margin-top: 20px;
    }
  }
}

.modalButton {
  margin-top: 30px;
  display: flex;
  flex-direction: column-reverse;

  @include mixins.media() {
    flex-direction: row;
    justify-content: center;

    .btn {
      width: 215px;
    }
  }

  .btn:last-child {
    margin-bottom: 20px;

    @include mixins.media() {
      margin-bottom: 0;
      margin-left: 16px;
    }
  }
}
</style>
